<template>
  <div class="container-fluid" id="flotilla">
<div class="col-md-12 flecha-container">  
  <h1 data-aos="fade-up"  data-aos-duration="1500">FLOTILLA</h1>
    <img data-aos="fade-right"  data-aos-duration="1500" class="flecha" src="~imgs/icons/Flecha_Negra.png">
  </div>    <div class="row flotillas-content-container">
      <div class="col-sm-12 col-md-6">
         <div data-aos="fade-right"  data-aos-duration="500" class="flotillas-updiv-img" style="z-index:4;" ><img class="flotillas-updiv-img-truck" src="~imgs/flotillas_truck4.png"></div>
         <div data-aos="fade-right"  data-aos-duration="1500" class="flotillas-updiv-img" style="z-index:3;" ><img class="flotillas-updiv-img-truck" src="~imgs/flotillas_truck3.png"></div>
         <div data-aos="fade-right"  data-aos-duration="2000" class="flotillas-updiv-img" style="z-index:2;" ><img class="flotillas-updiv-img-truck" src="~imgs/flotillas_truck2.png"></div>
         <div data-aos="fade-right"  data-aos-duration="4000" class="flotillas-updiv-img" style="z-index:1;" ><img class="flotillas-updiv-img-truck" src="~imgs/flotillas_truck1.png"></div>
      </div>
      <div  class="col-sm-12 col-md-6">
        <p  data-aos="fade-up"  data-aos-duration="1500" class="flotillas-updiv-text">En A&A nuestra flotilla cuenta con unidades de las marcas International Prostar y Freightliner, todas en óptimas condiciones para entregas a cualquier punto de E.U.A. Contamos con servicio de mantenimiento a las unidades, departamento de lavado, mantenimiento preventivo correctivo y departamento de diagnóstico y reparación. </p>
        </div>
      </div>
       <div class="row flotillas-content-container">
       <div class="col-md-6">
        <p data-aos="fade-up"  data-aos-duration="1500" class="flotillas-bottomdiv-text">Nuestra flotilla se compone de cajas secas de 53 pies de longitud listas para nuestros clientes. También contamos con servicio de almacenamiento de cajas cargadas en espera de documentación para ser exportadas y con unidades vacías listas para ser cargadas.  </p>
      </div>
      <div  class="col-md-6 col-sm-hidden">
         <div data-aos="fade-up"  data-aos-duration="1500"  class="flotillas-bottomdiv-img" ><img class="flotilla-truckimg" src="~imgs/flotillas_dry.png"></div>
         
      </div>
    </div>
  </div>
</template>

<script>

import Arrow from './reusable/ArrowRight.vue'
export default{
  data(){
    return{

    }
  },
  props:['name', 'selector'],
  components: {
    Arrow
  }
}


</script>

<style lang="scss" scoped>
@import '~varmix';
#flotilla{
  height: 100%;
  height: 100%;
  border-top:20px;
  border-top:30px;
}

.flotillas-content-container{
  padding:0px!important;
  margin-top:60px;
}

.flotillas-updiv-img{
  position:relative;
  display:inline-block;
  width:30%;
  margin-left:-80px;
}
.flotillas-updiv-img-truck{
  position:relative;
  width:100%;
  
}

.flotillas-bottomdiv-img{
  width:100%;
  text-align:right;
}

.flotilla-truckimg{
    width:80%;
    vertical-align:top;
}

.flotillas-updiv-text{
  padding:40px;
  
}
.flotillas-bottomdiv-text{
    padding:40px;
}

@media screen and (max-width: 720px){
 .flotillas-content-container{
   margin-top:20px;
 }
  .flotillas-updiv-img{

  width:25%;
  margin-left:-20px;
}
.flotillas-updiv-text{
  padding:10px;
}
.flotillas-bottomdiv-text{
    padding:10px;
}
.flotilla-truckimg{
    display:none;
}
}

.flecha-container{
  width:100%;
  text-align:left;
}
.flecha-container h1{
float:right;
margin-right:20px;
margin-top:20px;

font-size:30pt;
}
.flecha{
margin-left:-30px;
margin-top:20px;
width:80%;
}
</style>



// WEBPACK FOOTER //
// flotilla.vue?fb99952c